module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "titlepage",
      "id": "bk"
    }
  }, [_c('h1', {
    staticClass: "bk"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "piii"
    }
  }), _vm._v("The Sacking of Fallujah")]), _vm._v(" "), _c('h1', {
    staticClass: "bk1"
  }, [_vm._v("A People’s History")]), _vm._v(" "), _c('p', {
    staticClass: "bkau"
  }, [_vm._v("R"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OSS")]), _vm._v(" C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("APUTI")])]), _vm._v(" "), _c('p', {
    staticClass: "bkau"
  }, [_vm._v("R"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ICHARD")]), _vm._v(" H"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("IL")])]), _vm._v(" "), _c('p', {
    staticClass: "bkau"
  }, [_vm._v("D"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ONNA")]), _vm._v(" M"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ULHEARN")])]), _vm._v(" "), _c('p', {
    staticClass: "bkpub"
  }, [_vm._v("University of Massachusetts Press")]), _vm._v(" "), _c('p', {
    staticClass: "bkpub1"
  }, [_c('i', [_vm._v("Amherst and Boston")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-693ce7d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uma-CAPUTI-0004.vue
// module id = 66
// module chunks = 0